export default "__VITE_ASSET__53bbba3c__"